// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"5":"497b5d8c","748":"f5e043ee","1275":"cdbb714d","1625":"58683162","5216":"6e23434c","6642":"e80a1f63"}[chunkId] + ".css";
};